module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAvklEQVR4nO3bsW0CQBBE0REVUIpLcKeUQgmUQgl2QkaAYAYS3pNOJ21wwQ8u2wAAAAAAn3BMcrrdvOCc5C/JRcTX/CS5itgRcUDEAREHRBwQcUDEAREHRBwQcUDEAREHRBwQcUDEAREHRBwQcUDEAREHRBx4a8Tf28PfdB5GPNxNoOAfLIhXEK8gXkG8gngF8QriFcQriFcQryBeQbyCeAXxCuIVxCuIVxCvIF5BvIJ4JeuuJQvXAAAAAPCEJP/bdccaRTnP7AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/ic_arrow_bk@2x.png
// module id = 1086
// module chunks = 0